import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useLayoutEffect, useRef, useState } from 'react';
import { fitChipsToWidth, hiddenChipsLabel } from '../../../../../utils/fitChipsToWidth';
import { getTestIds } from '../../../../../utils/TestIds';
import { Row } from '../../../../Layout';
import { StatusBadge } from '../../../../StatusBadge';
import { Tooltip } from '../../../../Tooltip';
import { Typography } from '../../../../Typography';
import styles from '../cells.module.scss';
import { asStringList } from '../cellValues';
export function TagChips(param) {
    let { value, emptyText, testId } = param;
    const tags = asStringList(value);
    const testIds = getTestIds(testId);
    const hostRef = useRef(null);
    const measureRef = useRef(null);
    const [visibleCount, setVisibleCount] = useState(tags.length);
    useLayoutEffect(()=>{
        const host = hostRef.current;
        const measure = measureRef.current;
        if (host == null || measure == null) return;
        const refit = ()=>{
            const [counter, ...chips] = Array.from(measure.children);
            setVisibleCount(fitChipsToWidth({
                widths: chips.map((chip)=>chip.getBoundingClientRect().width),
                counterWidth: counter.getBoundingClientRect().width,
                available: host.getBoundingClientRect().width
            }));
        };
        refit();
        const observer = new ResizeObserver(refit);
        observer.observe(host);
        return ()=>observer.disconnect();
    }, [
        tags
    ]);
    const overflowCount = tags.length - visibleCount;
    if (tags.length === 0) {
        return /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            skin: "disabled",
            testId: testId,
            children: emptyText
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        ref: hostRef,
        className: styles.tagChipsHost,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                ref: measureRef,
                className: styles.tagChipsMeasure,
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ _jsx(StatusBadge, {
                        className: styles.tagChip,
                        children: "+".concat(tags.length)
                    }),
                    tags.map((tag)=>/*#__PURE__*/ _jsx(StatusBadge, {
                            className: styles.tagChip,
                            children: tag
                        }, tag))
                ]
            }),
            /*#__PURE__*/ _jsxs(Row, {
                alignItems: "center",
                gap: 6,
                className: styles.tagChips,
                testId: testId,
                children: [
                    tags.slice(0, visibleCount).map((tag, index)=>/*#__PURE__*/ _jsx(StatusBadge, {
                            className: styles.tagChip,
                            testId: testIds.chip(index),
                            children: tag
                        }, tag)),
                    overflowCount > 0 && /*#__PURE__*/ _jsx(Tooltip, {
                        title: hiddenChipsLabel({
                            labels: tags,
                            visibleCount
                        }),
                        children: /*#__PURE__*/ _jsx(StatusBadge, {
                            className: styles.tagChip,
                            testId: testIds.overflow(),
                            children: "+".concat(overflowCount)
                        })
                    })
                ]
            })
        ]
    });
}
